// extracted by mini-css-extract-plugin
export default {"FooterSection":"FooterSection_FooterSection__Zp-K6","Stack":"FooterSection_Stack__f68q8","MapImage":"FooterSection_MapImage__YPUaK"};